module.exports = __webpack_public_path__ + "img/lk.0cbb8160.svg";